// 判断数据类型
export const myTypeOf = (item) => {
  return Object.prototype.toString.call(item).slice(8, -1)
}
